import secureClient from 'lib/secure-client';
import apiUrl from 'shared_js/helpers/urlHelper/apiUrl';

function retrieveAddresses() {
  return this.get(`${apiUrl}/info/addresses`);
}

function retrieveSubdistricts(province, city, area) {
  return this.get(`${apiUrl}/info/addresses/subdistricts`, 'public', {
    params: {
      province,
      city,
      district: area,
    },
  });
}

function retrievePostCodes(province, city, area) {
  return this.get(`${apiUrl}/info/addresses/post-codes`, 'public', {
    params: {
      province,
      city,
      district: area,
    },
  });
}

/**
 * Collection of public user api
 */
const publicAddressApi = secureClient(
  {
    retrieveAddresses,
    retrieveSubdistricts,
    retrievePostCodes,
  },
  'xhrPublicAgentApi',
);

export default publicAddressApi;
